import { render, staticRenderFns } from "./component-customer.vue?vue&type=template&id=0ad3c59f&scoped=true&"
import script from "./component-customer.vue?vue&type=script&lang=js&"
export * from "./component-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad3c59f",
  null
  
)

export default component.exports